<div class="content-wrapper">
    <div class="row my-5 pb-5">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 p-0" style="background: url('/assets/intro_slide.jpg')center center no-repeat; background-size: cover;">
            <div class="container h-100 px-5" style="background: rgba(255, 255, 255, 0.6); padding: 40% 0 40%">
                <div class="uppercase main-color font-weight-medium text-center">{{'Our Service' | translate}}</div>
                <h2 class="text-color font-weight-semibold text-center">
                    {{'Discover More About Service Provided By Us' | translate}}
                </h2>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 py-5">
            <div class="container px-5">
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Design & Design Assist Development' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Project Mangement / Art Direction' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Artificial Rock, Tree & Vine' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Arichitectural Decorative Element' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Mural Artwork & Scenic Painting' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Sculpture' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Themed Retail, Booth & Cart' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Signage & Graphic Work' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Themed Set Building' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Props Manufacture' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Water Feature' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mb-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Aquarium' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div id="contact">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-lg-12">
                    <h1 class="display-6 font-weight-medium pb-3 text-center"><strong>{{'Our Service' | translate}}</strong></h1>
                </div>
            </div>  
        </div>
    </div>
    <div class="container wow animate__fadeInUp" id="about">
        <div class="pt-5 mt-5 pb-5">
            <div class="uppercase main-color font-weight-medium text-center">{{'Our Service' | translate}}</div>
            <h2 class="text-color font-weight-semibold text-center">
                {{'Discover More About Service Provided By Us' | translate}}
            </h2>
            <p class="font-size-14 accent-text-color text-center">
                Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor incididunt <br class="d-none d-sm-block"> soluta nobis assumenda labore quod maxime.
            </p>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="d-flex">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Design & Design Assist Development' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mt-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Project Mangement / Art Direction' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Artificial Rock, Tree & Vine' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mt-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Arichitectural Decorative Element' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Mural Artwork & Scenic Painting' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mt-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Sculpture' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="d-flex">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Themed Retail, Booth & Cart' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mt-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Signage & Graphic Work' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Themed Set Building' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mt-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Props Manufacture' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right fi-icon"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Water Feature' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
                <div class="d-flex mt-3">
                    <div>
                        <i class="icon-16 main-color fi-rr-arrow-small-right"></i>
                    </div>
                    <div class="ps-2">
                        <span class="main-color font-weight-medium">{{'Aquarium' | translate}}</span>
                        <p class="font-size-14 accent-text-color">
                            Non pulvinar neque laoreet suspendisse interdum. Sed adipiscing diam donec adipiscing tristique risus.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>

